import { Box, Button, Flex, HStack, Image } from "@chakra-ui/react";
import React from "react";

interface HeaderProps {
  isMenu?: boolean;
  logoRedirectUrl?: string;
}

export const Header: React.FC<HeaderProps> = ({ logoRedirectUrl }) => (
  <Box
    as="header"
    w="100%"
    bg="rgba(255,255,255,0.9)"
    backdropFilter="saturate(180%) blur(10px)"
    borderBottom="1px solid rgba(67,0,152,0.08)"
    position="sticky"
    top={0}
    zIndex={100}
  >
    <Flex maxW="1240px" mx="auto" px={{ base: "20px", md: "40px", xl: "56px" }} h={{ base: "64px", md: "72px" }} align="center" justify="space-between">
      <a href={logoRedirectUrl ?? "/"} style={{ display: "flex" }} aria-label="Strona główna">
        <Image src="/LBP_Logo_Black.svg" alt="lubbezpośrednio.pl" h={{ base: "28px", md: "32px" }} />
      </a>

      <HStack spacing="10px">
        <Button as="a" href="/logowanie" variant="ghost" color="primary" fontWeight="700" borderRadius="12px" size="sm" _hover={{ bg: "rgba(67,0,152,0.06)" }}>
          Zaloguj się
        </Button>
        <Button as="a" href="/rejestracja" bg="accent" color="white" fontWeight="700" borderRadius="12px" size="sm" px="18px" _hover={{ bg: "#c41a3a" }}>
          Zarejestruj się
        </Button>
      </HStack>
    </Flex>
  </Box>
);
